import HomeItems from "../Components/HomePage/HomeItems";
import Navbar from "../Components/NavbarItems/Navbar";
import Carousel from "../Components/Carousel/CarouselFunc";
import Footer from "../Components/FooterItems/Footer";
function Home() {
  return (
    <>
      <Navbar />
      <Carousel />
      <HomeItems />
      <Footer />
    </>
  );
}

export default Home;
